import { useGetAvailableSpecialFlagsQuery } from '@/common/infrastructure/gql/generated/schema';

const useAvailableSpecialFlags = () => {
  const { data, loading } = useGetAvailableSpecialFlagsQuery({ skip: false });

  return {
    loading,
    availableSpecialFlags: data?.raptorJobSupportingDataQuery.value.availableSpecialFlags ?? []
  };
};

export default useAvailableSpecialFlags;
